import { Component } from '@angular/core';

@Component({
  selector: 'app-treatment-policy',
  templateUrl: './treatment-policy.component.html',
  styleUrls: ['./treatment-policy.component.scss']
})
export class TreatmentPolicyComponent {

}
